<template>
    <Head title="Forgot Password" />
    <form @submit.prevent="submit">
    <div class="flex flex-column justify-content-center align-items-center guest-forms w-9 md:w-5 lg:w-3  mx-auto">
        <h1 class="text-center">RECUPERA LA PASSWORD</h1>
        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
        </div>

    <BreezeValidationErrors class="mb-4" />


            <span class="p-float-label mb-4 w-full">
	        <InputText id="username" type="email" v-model="form.email" required autofocus autocomplete="username" class="w-full"  />
	        <label for="username">Email</label>
            </span>
           <Button label="INVIA RICHIESTA" class="p-button-raised p-button-rounded p-button-secondary mt-1 w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" />


        <div class="mt-4 w-full text-center">
             <Link  class="underline text-sm  hover:text-gray-900 " :href="route('login')">
                TORNA AL LOG-IN
            </Link>
        </div>
    </div>
    </form>
</template>

<script>
import Button from 'primevue/button';
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import InputText from 'primevue/inputtext';
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import { Head,Link} from '@inertiajs/inertia-vue3';

export default {
    layout: BreezeGuestLayout,

    components: {
        Button,
        InputText,
        BreezeLabel,
        BreezeValidationErrors,
        Head,
        Link
    },

    props: {
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: ''
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.email'))
        }
    }
}
</script>
